@if (store.visible()) {
  <article
    class="rounded-xl border border-[var(--border)] bg-[var(--bg-surface)] p-3 shadow-sm"
    [attr.aria-label]="'onboardingChecklist.title' | t"
  >
    <header class="mb-2 flex items-center justify-between gap-2">
      <h3 class="text-[13px] font-semibold text-[var(--text)]">
        {{ 'onboardingChecklist.title' | t }}
      </h3>
      <span class="text-[11px] font-medium text-[var(--muted)]">
        {{ store.completedCount() }}/{{ store.total }} {{ 'onboardingChecklist.progress' | t }}
      </span>
    </header>

    <div class="mb-3 h-1 w-full overflow-hidden rounded-full bg-[var(--border)]">
      <div
        class="h-1 rounded-full bg-[var(--accent)] transition-all duration-300"
        [style.width.%]="progressPercent()"
      ></div>
    </div>

    <ul class="flex flex-col">
      @for (item of items; track item.key) {
        <li>
          <app-checklist-item
            [done]="isItemDone(item.flagKey)"
            [label]="'onboardingChecklist.items.' + item.key | t"
            [iconName]="item.iconName"
            [route]="getRoute(item)"
          />
        </li>
      }
    </ul>

    <footer class="mt-2 flex justify-end">
      <button
        type="button"
        class="text-[11.5px] font-medium text-[var(--muted)] underline-offset-2 hover:text-[var(--text)] hover:underline"
        (click)="onAlreadyDoneClick()"
      >
        {{ 'onboardingChecklist.buttonAlreadyDone' | t }}
      </button>
    </footer>
  </article>
}

<app-modal
  [visible]="showConfirmModal()"
  size="sm"
  [shrinkWrapBody]="true"
  [title]="'onboardingChecklist.confirmModal.title' | t"
  [stackAbove]="true"
  (closed)="onCancelDismiss()"
>
  <div modalBody class="confirm-body">
    <p class="confirm-text">{{ 'onboardingChecklist.confirmModal.description' | t }}</p>
  </div>
  <div modalFooter class="confirm-footer">
    <button
      type="button"
      class="confirm-cancel-btn"
      [disabled]="dismissing()"
      (click)="onCancelDismiss()"
    >
      {{ 'onboardingChecklist.confirmModal.buttonCancel' | t }}
    </button>
    <button
      type="button"
      class="confirm-primary-btn"
      [disabled]="dismissing()"
      (click)="onConfirmDismiss()"
    >
      @if (dismissing()) {
        <lucide-icon name="loader-circle" [size]="14" class="confirm-spin" aria-hidden="true"></lucide-icon>
        {{ 'onboardingChecklist.confirmModal.buttonConfirming' | t }}
      } @else {
        {{ 'onboardingChecklist.confirmModal.buttonConfirm' | t }}
      }
    </button>
  </div>
</app-modal>
